/*
 * View for the topic categories area where categories can be added/modified/removed
 * from a topic
 */

define([
  "marionette",
  "jquery",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesAddModal/template/category-template.html",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesAddModal/template/category-value-template.html",
], function (Marionette, $, CategoriesTemplate, CategoriesValueTemplate) {
  var TopicCategoriesModalAddView = {};

  TopicCategoriesModalAddView.categoryValuesView = Marionette.ItemView.extend({
    template: CategoriesValueTemplate,
  });

  TopicCategoriesModalAddView.categoryView = Marionette.CompositeView.extend({
    template: CategoriesTemplate,
    itemView: TopicCategoriesModalAddView.categoryValuesView,
    itemViewContainer: "ul",
    initialize: function () {
      this.collection = this.model.getValues();
    },
    events: {
      hidden: function (e) {
        e.stopPropagation();
      },
    },
  });

  TopicCategoriesModalAddView.accordionView = Marionette.CollectionView.extend({
    itemView: TopicCategoriesModalAddView.categoryView,

    events: {
      "click ul li :checkbox": "clicked",
    },

    clicked: function (e) {
      var $target = $(e.target);
      var selected = $target.is(":checked");

      // Check if select / deselect all checked
      if ($target.val().startsWith("addAll-")) {
        // Value is (categoryKey-categoryValue)
        this.processSelectAll($target.val().split("-")[1], selected);
      } else {
        // Category value checked / unchecked
        if (selected) {
          this.trigger("topic:categories:addModal:add", $target.val());
        } else {
          this.trigger("topic:categories:addModal:remove", $target.val());
        }
      }
    },

    processSelectAll: function (categoryId, selected) {
      if (selected) {
        this.selectAll(categoryId);
      } else {
        this.deselectAll(categoryId);
      }
    },

    selectAll: function (categoryId) {
      this.$el
        .find("#catListModal-" + categoryId)
        .find("input:checkbox")
        .each(function () {
          if (!$(this).is(":checked")) {
            $(this).trigger("click");
            $(this).prop("checked", true);
          } else {
            // category already checked and added to temp category model
            $(this).prop("checked", true);
          }
        });
    },

    deselectAll: function (categoryId) {
      this.$el
        .find("#catListModal-" + categoryId)
        .find("input:checkbox")
        .each(function () {
          if ($(this).is(":checked")) {
            $(this).trigger("click");
            $(this).prop("checked", false);
          } else {
            // category already checked and added to temp category model
            $(this).prop("checked", false);
          }
        });
    },
  });

  return TopicCategoriesModalAddView;
});
